/* eslint-disable max-lines */
import { extendTheme, ThemeConfig } from '@chakra-ui/react'

import { primaryColor } from './foundations/primaryColor'
import * as components from './components'
import * as foundations from './foundations'

const { colors, ...restFoundations } = foundations


const config: ThemeConfig = {
  initialColorMode: 'dark',
  useSystemColorMode: false,
}

export const themeColors = { ...primaryColor }

export const themeMercedes = extendTheme({
  config,
  colors: {
    ...colors,
    primaryColor,
  },
  ...restFoundations,
  components: {
    ...components,
    FormControlLabel: {
      baseStyle: {
        _text: {
          color: primaryColor.input.labelColorText,
        },
      },
    },
    Switch: {
      defaultProps: {
        size: 'md',
      },
      baseStyle: {
        onTrackColor: primaryColor.switch.bgOnTrackColor,
        offTrackColor: primaryColor.switch.bgOffTrackColor,
        onThumbColor: primaryColor.switch.bgOnThumbColor,
        offThumbColor: primaryColor.switch.bgOffThumbColor,
      },
    },
    Actionsheet: {
      baseStyle: {
        bg: primaryColor.modal.bgColor,
      },
      defaultProps: {
        size: 'full',
      },
    },
    ActionsheetContent: {
      baseStyle: {
        px: 5,
        pt: 5,
        borderRadius: 'none',
        roundedTop: 0,
        bg: primaryColor.modal.bgColorContent,
      },
    },
    PopoverContent: {
      baseStyle: {
        backgroundColor: primaryColor.container.bgHeaderColor,
        borderColor: primaryColor.container.bgHeaderColor,
        borderWidth: 1,
        borderRadius: 6,
      },
    },
    PopoverArrow: {
      baseStyle: {
        color: primaryColor.container.bgHeaderColor,
        borderColor: primaryColor.container.bgHeaderColor,
      },
    },
    Spinner: {
      baseStyle: {
        color: primaryColor.pressable.bgLoadingColor,
      },
    },
  },
})
